import { render } from "./MainMenu.vue?vue&type=template&id=34dc4ed7"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
script.render = render

export default script